import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "session_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach the session token (Bearer) so auth works even when the SPA and API
// live on different origins and cookies aren't shared.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Lets the auth layer react to expired/invalid sessions.
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401 && onUnauthorized) onUnauthorized();
    return Promise.reject(error);
  },
);

export const loginWithGoogle = async (credential) => {
  const { data } = await api.post("/auth/google", { credential });
  return data;
};

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } finally {
    setToken(null);
  }
};

export const fetchRentals = async (filters = {}) => {
  const params = {};
  Object.entries(filters).forEach(([k, v]) => {
    if (v === "" || v === null || v === undefined || v === false) return;
    params[k] = v;
  });
  const { data } = await api.get("/rentals", { params });
  return data;
};

export const parseUrl = async (url) => {
  const { data } = await api.post("/rentals/parse", { url });
  return data;
};

export const parseText = async ({ text, source_url, image_url }) => {
  const { data } = await api.post("/rentals/parse_text", {
    text,
    source_url: source_url || "",
    image_url: image_url || "",
  });
  return data;
};

export const createRental = async (payload) => {
  const { data } = await api.post("/rentals", payload);
  return data;
};

export const updateRental = async (id, payload) => {
  const { data } = await api.put(`/rentals/${id}`, payload);
  return data;
};

export const toggleFavorite = async (id) => {
  const { data } = await api.post(`/rentals/${id}/favorite`);
  return data;
};

export const deleteRental = async (id) => {
  const { data } = await api.delete(`/rentals/${id}`);
  return data;
};

export const fetchStats = async () => {
  const { data } = await api.get("/stats");
  return data;
};

// ---- Share ----
export const fetchShareStatus = async () => {
  const { data } = await api.get("/share/me");
  return data;
};

export const toggleShare = async () => {
  const { data } = await api.post("/share/toggle");
  return data;
};

export const fetchSharedList = async (token) => {
  const { data } = await api.get(`/share/${token}`);
  return data;
};

export const addToSharedList = async (token, payload) => {
  const { data } = await api.post(`/share/${token}/rentals`, payload);
  return data;
};

export const updateSharedRental = async (token, rentalId, payload) => {
  const { data } = await api.patch(`/share/${token}/rentals/${rentalId}`, payload);
  return data;
};
